export default {
  ADD_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications;
  },
  REMOVE_NOTIFICATION(state, notificationId) {
    const index = state.notifications.findIndex(notification => notification.id === notificationId);
    state.notifications.splice(index, 1);
  }
};